export default __webpack_public_path__ + "static/media/KanipakamdietieOne.e79b0dfa.png";